import { EntityPreviewsLayout } from "../../shared/layouts/EntityPreviewsLayout";
import { AccountSubmissionPreviewsAll } from "./AccountSubmissionPreviewsAll";
import { AccountSubmissionPreviewsClosed } from "./AccountSubmissionPreviewsClosed";
import { AccountSubmissionPreviewsOpen } from "./AccountSubmissionPreviewsOpen";

export const AccountSubmissionsView = () => {
	return (
		<EntityPreviewsLayout
			title="Account Submissions"
			storageKey="agent_account_submissions_view"
			tabs={[
				{
					id: "all",
					label: "All",
					Component: AccountSubmissionPreviewsAll,
				},
				{
					id: "open",
					label: "Open",
					Component: AccountSubmissionPreviewsOpen,
					isDefault: true,
				},
				{
					id: "closed",
					label: "Closed",
					Component: AccountSubmissionPreviewsClosed,
				},
			]}
		/>
	);
};
